<template>
  <nav class="navbar is-primary" role="navigation" aria-label="main navigation">
    <div class="container">
      <div class="navbar-brand">
        <logo class="navbar-item"></logo>
        <a
          class="navbar-burger burger"
          aria-label="menu"
          aria-expanded="false"
          data-target="navbar"
          v-on:click="menuIsActive = !menuIsActive"
          :class="{ 'is-active': menuIsActive }"
        >
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>

      <div
        id="navbar"
        class="navbar-menu"
        :class="{ 'is-active': menuIsActive }"
      >
        <navigation class="navbar-start"></navigation>
        <login class="navbar-end"></login>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  components: {
    Navigation: () =>
      import(
        /* webpackChunkName: "Navigation" */ '@/components/layout/Navigation'
      ),
    Login: () =>
      import(/* webpackChunkName: "Login" */ '@/components/layout/Login'),
    Logo: () => import('@/components/layout/Logo'),
  },
  data() {
    return {
      menuIsActive: false,
    }
  },
  mounted() {},
  watch: {
    $route() {
      this.menuIsActive = false
    },
  },
}
</script>
